import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import GlobalStyles from './global-style';

import { fetchData } from './state/slices/data';

import PageWrap from './views/pagewrap';
import store from './state/store';
import { setUpBrowserListeners } from './state/slices/browserUtils';

const container = document.getElementById('foot');
const root = createRoot(container);

// Change this to 'renewable' to make the renewable map the default build.
const DEFAULT_PROJECT = 'coal';
const requestedProject = new URLSearchParams(window.location.search).get(
  'project',
);
const PROJECT =
  requestedProject === 'renewable' ? 'renewable' : DEFAULT_PROJECT;

const element = (
  <Provider store={store}>
    <GlobalStyles />
    <PageWrap project={PROJECT} />
  </Provider>
);

root.render(element);

/* Initial data fetch */
setUpBrowserListeners(store.dispatch);
store.dispatch(fetchData());
